module.exports = __webpack_public_path__ + "img/profilwomen.517e5bef.svg";